import React from "react";
import FormGroup from "@mui/material/FormGroup";
import CCheckButton from "./CCheckButton";
import RadioGroup from "@mui/material/RadioGroup";

const CCheckGroup = ({ cId, cData, cIsSingle, cLabelEmpty, cOnChange, cIsSmall }) => {

  const onChange = (key, isChecked) => {
    if (cOnChange != undefined) {
      cOnChange(key, isChecked);
    }
  };

  if (cData === undefined || cData.length === 0) {
    return null;
  } else {
    const data = cData.data;
    const filters = cData.filters;
    const checks = cData.checks;
    // const disables = cData.disables; disables.has(item);cDisabled={item.isDisabled} todo
    const CheckBtnComponent = [...data.entries()].map(([key, item], index) =>
      filters.has(key) ? (
        <CCheckButton
          cId={cId}
          key={index}
          cLabel={item === null ? cLabelEmpty : item}
          cChecked={checks.has(key)}
          cIsSingle={cIsSingle}
          cHandleCheck={() => onChange(key, true)}
          cHandleUnCheck={() => onChange(key, false)}
          cIsSmall={cIsSmall}
        />
      ) : null
    );
    return cIsSingle ? (
      <RadioGroup sx={{ padding: "1em", height: "13.5em", overflowY: "auto" }}>
        {CheckBtnComponent}
      </RadioGroup>
    ) : (
      <FormGroup sx={{ padding: "1em", height: "13.5em", overflowY: "auto" }}>
        {CheckBtnComponent}
      </FormGroup>
    );
  }
};

export default CCheckGroup;
